import makeRequest from './helpers/makeRequest';

export interface TfTokenResponse {
  access_token: string;
  token_type: string;
  expires_in: number;
}

export const mintTfExchangeToken = (audience: string[]): Promise<TfTokenResponse> =>
  makeRequest<TfTokenResponse>({
    method: 'POST',
    pathname: 'token/exchange',
    body: { audience, claims: {} }, // TODO: Add what claims after discussing with Business Systems team
  });
